import { RootState } from '../../RootState';
import { WishlistsState } from '@spa/lib/store/wishlists/WishlistsState';

const selectWishlistPageActions = (state: RootState): WishlistsState['pageActions'] => {
  return state.wishlists.pageActions;
};

export default selectWishlistPageActions;
